export const actions = {
  async fetchGridSettingsByCode({commit}, gridName) {
    return await this.$axios.$get('/GridSetting/' + gridName)
  },
  async saveGridSetting({commit}, {gridSettings}) {
    return await this.$axios.$post('/GridSetting/', gridSettings)
  },
}
